import NeedSlideWrap from "@/app/homepage/main/component/NeedSlideWrap";
import {NEEDS_SLIDE_ITEMS} from "@/app/homepage/main/controller";
import CustomSwiper from "@/components/common/CustomSwiper";
import styled, {keyframes} from "styled-components";
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";

const NeedsWrap = ({className}) => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const text = "What You Need";
    return(
        <Needs className={className}>
            <div className={"wrap-title"}>
                <div className={"wave-text"}>
                    {text.split("").map((ch, idx) => (
                        <span key={idx} className={`${ch === " " ? "is-space" : ""}`}>{ch === " " ? "\u00A0" : ch}</span>
                    ))}
                </div>
            </div>
            {
                !isTablet ?
                    <div className={"needs-slide-wrap-pc"}>
                        <NeedSlideWrap slide={NEEDS_SLIDE_ITEMS}/>
                    </div>
                    :
                    <div className={"needs-slide-wrap-mo"}>
                        <CustomSwiper
                            slides={NEEDS_SLIDE_ITEMS}
                            effect="slide"
                            className="needs-vertical-swipe"
                            direction={"vertical"}
                            slidesPerView={"3"}
                            spaceBetween={16}
                            // slidesPerGroup={3}
                            nested={true}
                            touchReleaseOnEdges={true}
                        />
                    </div>
            }
        </Needs>
    )
}
const waveUp = keyframes`
    0% {
        transform: translateY(100%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
`;
const Needs = styled.div`
    padding: 140px 0 220px;
    background: linear-gradient(180deg, #2E0B7E 0%, #0A0323 100%);
    .wrap-title{
        margin-bottom: 100px;
        font-weight: 700;
        font-size: 48px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #FFFFFF;
    }
    .wave-text{
        display: inline-block;
        overflow: hidden;
        span {
            display: inline-block;
            transform: translateY(100%);
            opacity: 0;
        }
        .is-space {
            width: 0.3em; /* 필요하면 0.4em~0.6em 사이로 조절 */
        }
    }
    &.active{
        .wave-text{
            span {
                animation: ${waveUp} 0.6s ease-out forwards;
            }
            span:nth-child(1) { animation-delay: 0s; }
            span:nth-child(2) { animation-delay: 0.1s; }
            span:nth-child(3) { animation-delay: 0.2s; }
            span:nth-child(4) { animation-delay: 0.3s; }
            span:nth-child(6) { animation-delay: 0.5s; }
            span:nth-child(7) { animation-delay: 0.6s; }
            span:nth-child(8) { animation-delay: 0.7s; }
            span:nth-child(10) { animation-delay: 0.9s; }
            span:nth-child(11) { animation-delay: 1s; }
            span:nth-child(12) { animation-delay: 1.1s; }
            span:nth-child(13) { animation-delay: 1.2s; }
        }
    }
    .needs-slide-wrap-pc{
        width: 100%;
        transform: scaleX(0);
        transform-origin: left;
        transition: all 0.8s ease-in-out;
        transition-property: transform;
        overflow: hidden;
    }
    .needs-slide-wrap-mo{
        width: 100%;
        opacity: 0;
        transform: translateY(100px);
        transition: all 0.8s ease-in-out;
        overflow: hidden;
    }
    &.active{
        .needs-slide-wrap-pc{
            transform: scaleX(1);
        }
        .needs-slide-wrap-mo{
            opacity: 1;
            transform: translateY(0);
        }
    }


    @media (max-width: ${SIZES.TABLET}) {
        background: #5435DC;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 110px 0 128px;
        .wrap-title{
            margin-bottom: 30px;
            font-weight: 700;
            font-size: 32px;
            line-height: 100%;
            letter-spacing: -0.02em;
        }
        .needs-slide-wrap-mo{
            width: 100%;
            padding: 0 20px 0;
            //transform: scaleX(1);
            .needs-vertical-swipe{
                height: 100%;
                .swiper{
                    height: 512px;
                    .swiper-slide{
                        width: 100%;
                        height: 160px !important;
                        border-radius: 20px;
                        overflow: hidden;
                    }
                    .image-wrap{
                        width: 100%;
                        height: 100%;
                        position: relative;
                        &::after{
                            content: "";
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            background-color: rgba(0, 0, 0, .5);
                        }
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.2);
                        }
                    }
                    .desc-wrap{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 100%;
                        text-align: center;
                        letter-spacing: 0.02em;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
`

export default NeedsWrap;